<template>
  <canvas ref="canvas" :width="width" :height="height" />
</template>

<script>
// Ver el comentario en ChartjsLine.vue — mismo reemplazo de
// 'hchs-vue-charts', mismo criterio (mount-once, `option` siempre
// provisto por el único consumidor real: DashboardPanel.vue).
export default {
  name: 'ChartjsDoughnut',
  props: {
    labels: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    datalabel: { type: String, default: 'dataset' },
    width: { type: Number, default: null },
    height: { type: Number, default: null },
    backgroundcolor: {
      default: () => ['#FF6384', '#36A2EB', '#FFCE56', '#00A600'],
    },
    hoverbackgroundcolor: {
      default: () => ['#FF6384', '#36A2EB', '#FFCE56', '#00A600'],
    },
    bordercolor: { default: '#fff' },
    option: { type: Object, default: null },
  },
  data() {
    return { chart: null };
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [
            {
              label: this.datalabel,
              backgroundColor: this.backgroundcolor,
              borderColor: this.bordercolor,
              hoverBackgroundColor: this.hoverbackgroundcolor,
              hoverBorderColor: this.hoverbackgroundcolor,
              data: this.data,
            },
          ],
        },
        options: this.option || {},
      });
    },
  },
};
</script>
